import styled from 'styled-components';

export default styled.div<{ isSelected?: boolean }>`
  display: grid;
  background: white;
  border: 2px solid
    ${({ isSelected, theme }) =>
      isSelected ? theme.primary[500] : theme.gray[50]};
  box-shadow: 0 0 2px rgba(40, 41, 61, 0.04), 0 4px 8px rgba(96, 97, 112, 0.16);
  border-radius: 6px;
  grid-template-columns: 1fr 22.4rem;
  position: relative;
  min-height: 24.6rem;
`;
